import {useQuery} from "react-query";
import {
    getFrequentPassageStickerType,
} from "../../../services/api/frequentPassageStickerTypes";

export const FREQUENT_PASSAGE_STICKER_TYPE_SINGLE_QUERY_KEY = "FREQUENT_PASSAGE_STICKER_TYPE_SINGLE_QUERY_KEY";

export const useFrequentPassageStickerType = (id: undefined | number, options = {}) => {
    return useQuery([FREQUENT_PASSAGE_STICKER_TYPE_SINGLE_QUERY_KEY, id], () => {
        if (!id) return Promise.resolve(undefined);
        return getFrequentPassageStickerType(id);
    }, options);
};
